import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { queryKeys } from '../react-query.config';
import type { FeedFixture } from './getFeedFixtures';

interface FeedFixtureByIdResponse {
  fixture: FeedFixture;
}

export const getFeedFixtureById = async (fixtureId: string): Promise<FeedFixture> => {
  const response = (await api.get(`/feed/fixtures/${fixtureId}`)) as FeedFixtureByIdResponse;
  return response.fixture;
};

export const useGetFeedFixtureByIdQuery = (fixtureId: string | undefined) => {
  return useQuery({
    queryKey: queryKeys.feed.fixtureById(fixtureId || ''),
    queryFn: () => getFeedFixtureById(fixtureId!),
    enabled: !!fixtureId,
    staleTime: 5 * 60 * 1000,
  });
};
